var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-74",
    fill: "#F33630",
    mask: "url(#mask-2)",
    points: "6.66666667 18.6666667 26.6666667 0 28 0 28 20 6.66666667 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-74-Copy",
    fill: "#009643",
    mask: "url(#mask-2)",
    transform: "translate(10.666667, 10.000000) scale(-1, -1) translate(-10.666667, -10.000000) ",
    points: "5.68434189e-14 18.6666667 20 0 21.3333333 0 21.3333333 20 5.68434189e-14 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-69-Copy",
    fill: "#FCDF4A",
    mask: "url(#mask-2)",
    transform: "translate(14.412496, 9.532967) rotate(134.000000) translate(-14.412496, -9.532967) ",
    points: "-4.9208373 6.19963333 33.7458294 6.19963333 33.7458294 12.8663 -4.9208373 12.8663"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/CG.4a72a9cc46dab013cf4ec850bc2d4bb7.svg";
export { ForwardRef as ReactComponent };